import React from "react";
import { FormOutlined, AudioOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ProductLockPage from "components/ProductLock/ProductLockPage";
import lockStyles from "components/ProductLock/style.module.scss";

const SurveyLockPage = ({ theme, userId, onActivated }) => {
  const { t } = useTranslation();
  return (
    <ProductLockPage
      productKey="survey"
      theme={theme}
      userId={userId}
      onActivated={onActivated}
    >
      <div className={lockStyles.lockCardGhostOne}>
        <FormOutlined />
        <span>{t("survey_lock.ghost_survey")}</span>
        <strong>{t("survey_lock.ghost_live")}</strong>
      </div>
      <div className={lockStyles.lockCardGhostTwo}>
        <AudioOutlined />
        <span>{t("survey_lock.ghost_voice")}</span>
        <strong>{t("survey_lock.ghost_capture")}</strong>
      </div>
    </ProductLockPage>
  );
};

export default SurveyLockPage;
